// Header returned by authenticated APIs when the user's tenant does not match
// the portal they are visiting (e.g. a leisure user on the vesper portal). Its
// value is the fully-qualified portal URL the user should be redirected to.
export const X_REDIRECT_TO_HEADER = "x-redirect-to";

/**
 * Validates an `X-Redirect-To` header value against an allowlist of Capital One
 * domains to guard against open redirects, then returns the normalized URL to
 * navigate to. Returns `null` when the value is missing or not a trusted URL.
 */
export const getValidatedRedirectUrl = (
  headerValue?: string | null
): string | null => {
  if (!headerValue) return null;

  try {
    const url = new URL(headerValue);
    const isHttps = url.protocol === "https:";
    const isCapitalOneDomain =
      url.hostname === "capitalone.com" ||
      url.hostname.endsWith(".capitalone.com");

    if (isHttps && isCapitalOneDomain) {
      return url.href;
    }
  } catch {
    // Not a parseable absolute URL — ignore.
  }

  return null;
};

const LOCAL_HOSTNAMES = ["localhost", "127.0.0.1", "0.0.0.0"];

export const isLocalHostname = (hostname?: string | null): boolean =>
  !!hostname && LOCAL_HOSTNAMES.includes(hostname);
